import React from 'react'
import { DashboardContentContainer, TabContainer } from './styles'
import { TimelineMaternalInfant } from '../../shared/TimelineMaternalInfant'
import { MaternalInfantSidePanel } from '../../shared/SidePanel'
import { Tabs } from '~/components/shared'
import { message } from '~/services'
import { OpenCloseProvider } from '~/context'
import { VaccinesProvider } from '~/context/vaccines'
import { Vaccines } from '~/components/generalMedicalView'

export const MotherTimelineView: React.FC = () => {
  return (
    <TabContainer>
      <Tabs>
        <Tabs.Options>
          <Tabs.Item>{message('maternalInfant.timeline')}</Tabs.Item>
          <Tabs.Item>{message('timeline.vaccines')}</Tabs.Item>
        </Tabs.Options>

        <Tabs.Content>
          <DashboardContentContainer>
            <OpenCloseProvider>
              <TimelineMaternalInfant />
              <MaternalInfantSidePanel />
            </OpenCloseProvider>
          </DashboardContentContainer>
          <VaccinesProvider>
            <Vaccines />
          </VaccinesProvider>
        </Tabs.Content>
      </Tabs>
    </TabContainer>
  )
}
